// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Vp-z","imageAndVideoCount":"Wp-z","imageAndVideoContainer":"Xp-z","viewAllReviews":"Yp-z"};